var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSeeChat)?_c('router-link',{staticClass:"chat-messages base-tooltip",attrs:{"to":{ name: 'chat' },"data-tooltip":_vm.$t('labels.goToChat')}},[_c('Chat'),(_vm.numberOfUnreadMessages)?_c('span',{staticClass:"num-of-messages p-small-medium"},[_vm._v(_vm._s(_vm.numberOfUnreadMessages))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }